import { useCallback } from "react";

declare global {
  interface Window {
    SpeechRecognition: any;
    webkitSpeechRecognition: any;
  }
}

let recognition: any = null;

interface VoiceHandlers {
  onStart?: () => void;
  onResult?: (transcript: string, isFinal: boolean) => void;
  onEnd?: () => void;
  onError?: (error: string) => void;
}

function getSpeechRecognition() {
  if (typeof window === "undefined") return undefined;
  return window.SpeechRecognition || window.webkitSpeechRecognition;
}

export const useVoiceRecognition = () => {
  const isSupported = !!getSpeechRecognition();

  const startListening = useCallback((handlers: VoiceHandlers = {}) => {
    const SpeechRecognition = getSpeechRecognition();
    if (!SpeechRecognition) {
      handlers.onError?.("not-supported");
      return;
    }

    const instance = new SpeechRecognition();
    recognition = instance;
    instance.lang = "ko-KR";

    instance.onstart = () => handlers.onStart?.();

    instance.onresult = (event: any) => {
      let transcript = "";
      for (let i = 0; i < event.results.length; i++) {
        transcript += event.results[i][0].transcript;
      }

      const isFinal = event.results[event.results.length - 1].isFinal;
      handlers.onResult?.(transcript, isFinal);
    };

    instance.onerror = (event: any) => handlers.onError?.(event.error);

    instance.onend = () => {
      handlers.onEnd?.();

      if (recognition === instance) recognition = null;
    };

    instance.start();
  }, []);

  const stopListening = useCallback(() => {
    recognition?.stop();
  }, []);

  const cancelListening = useCallback(() => {
    recognition?.abort();
  }, []);

  return { startListening, stopListening, cancelListening, isSupported };
};
